import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Circle } from '../IconBase/IconBase'

function CirclePlus({
  color = 'icon.primary',
  strokeColor = 'icon.white',
  strokeWidth = 2,
  borderColor = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='-1 -1 22 22' {...props}>
      <Circle
        cx='10'
        cy='10'
        r='10'
        fill={color}
        stroke={borderColor ?? strokeColor}
      />
      <Path
        d='M10.0019 13.6809L10.0019 6.3125'
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13.6875 9.99807L6.31908 9.99807'
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

CirclePlus.propTypes = {
  color: PropTypes.string,
  strokeColor: PropTypes.string,
  borderColor: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default CirclePlus
